import { render, staticRenderFns } from "./rightsAndInterests.vue?vue&type=template&id=dbbf4084&scoped=true&"
import script from "./rightsAndInterests.vue?vue&type=script&lang=js&"
export * from "./rightsAndInterests.vue?vue&type=script&lang=js&"
import style0 from "./rightsAndInterests.vue?vue&type=style&index=0&id=dbbf4084&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbbf4084",
  null
  
)

export default component.exports